!function(window) {
/**
 *
 * @param {array} aParams
 * @param {array} aExcluded
 * @param {function} callback
 */
function getFilterResults(aParams, aExcluded, callback){
	$.get(
		`/util/ajaxresponse.php?lng=${pageLng}&${createParamsString(aParams, [])}`,
		function(data) {
			
			if(data == ''){
				return;
			}
			
			if(callback){
				var jqueryHtml = $(data);
				callback(jqueryHtml);
			}
			
			setSimplePagination();
			
			var params = `${createParamsString(aParams, aExcluded)}`;
			
			if (history){
				if(params !== ''){
					params = '?' + params;
				}else{
					params = window.location.pathname;
				}
				history.pushState(null, null, params);
			}
			//window.scrollTo(0, 200);
		}
	).fail(
		function(data){
			$('.data-content').html("Error occurred!");
		}
	)
	
	function createParamsString(aParams, aExcluded){
		return Object.keys(aParams)
				.filter((key) => aExcluded.indexOf(key) === -1)
				.reduce((joined, current) => {
					if( current == 'map' ){ // exception
						return joined + `&${current}`;
					}
					if( aParams[current] === null || aParams[current] === ''){
						return joined;
					}
					return joined + `&${current}=${aParams[current]}`
				}, '').substring(1);
	}
}

function onPaginationNewsClick(pageNumber, e){
	e.preventDefault();
	
	var strid = $('#body-content').attr('data-strid');
	var page = pageNumber;
	
	const urlParams = new URLSearchParams(window.location.search);
	const year = urlParams.get('year');
	
	getFilterResults({func: 'get-page-news', page: page, str: strid, year: year}, ['func', 'str'], function(jqueryHtml){
		$('.data-content').empty();
		$('.data-content').append(jqueryHtml);
	});
}

function onPaginationEventsClick(pageNumber, e){
	e.preventDefault();
	
	var strid = $('#body-content').attr('data-strid');
	var page = pageNumber;
	
	const urlParams = new URLSearchParams(window.location.search);
	const dateFrom = urlParams.get('dateFrom');
	const dateTo = urlParams.get('dateTo');
	
	getFilterResults({func: 'get-page-events', page: page, str: strid, dateFrom: dateFrom, dateTo: dateTo }, ['func', 'str'], function(jqueryHtml){
		$('.data-content').empty();
		$('.data-content').append(jqueryHtml);
	});
}

function onPaginationTendersClick(pageNumber, e){
	e.preventDefault();
	
	var strid = $('#body-content').attr('data-strid');
	var page = pageNumber;
	var status = $('#status').val();
	
	getFilterResults({func: 'get-tenders', page: page, str: strid, status: status }, ['func', 'str'], function(jqueryHtml){
		$('.data-content').empty();
		$('.data-content').append(jqueryHtml);
	});
}

function onPaginationMaterialsClick(pageNumber, e){
	e.preventDefault();
	
	var strid = $('#body-content').attr('data-strid');
	var page = pageNumber;
	
	getFilterResults({func: 'get-materials', page: page, str: strid }, ['func', 'str'], function(jqueryHtml){
		$('.materials').empty();
		$('.materials').append(jqueryHtml);
	});
}

function callNewPageData(pageNumber, event, functionName){
	if(functionName == 'get-news'){
		onPaginationNewsClick(pageNumber, event);
	}else if(functionName == 'get-events'){
		onPaginationEventsClick(pageNumber, event);
	}else if(functionName == 'get-tenders'){
		onPaginationTendersClick(pageNumber, event);
	}else if(functionName == 'get-materials'){
		onPaginationMaterialsClick(pageNumber, event);
	}
}

function setSimplePagination(){
	if($('.pagination').length){
		//var currentTheme = $('html').attr('data-theme');
		$('.pagination').pagination({
			displayedPages: 5,
			edges: 1,
			ellipsePageSet: false,
			items: $('.pagination').attr('data-total'),
			itemsOnPage: $('.pagination').attr('data-limit'),
			currentPage : $('.pagination').attr('data-current'),
			nextText: '<svg xmlns="http://www.w3.org/2000/svg" width="12.828" height="22.829" viewBox="0 0 13 24"><path d="m1.414 1.415 10 10-10 10" fill="none" stroke="#222" stroke-linecap="round" stroke-width="2"/></svg>',
			prevText: '<svg xmlns="http://www.w3.org/2000/svg" width="12.828" height="22.829"viewBox="0 0 13 24"> <path d="m11.586 1.415-10 10 10 10" fill="none" stroke="#222" stroke-linecap="round" stroke-width="2"/></svg>',
			onPageClick: function(pageNumber, event) {
				var functionName = $('.pagination').attr('data-func');
				callNewPageData(pageNumber, event, functionName);
			}
		});
	}
}
setSimplePagination();

function formatDate(date){
	var aDate = date.split(".");
	return aDate[2]+'-'+aDate[1]+'-'+aDate[0];
}

function setDependentDate(){
	$( ".datepicker-here.start" ).datepicker({
		onSelect: function( selectedDate ) {
			$(".datepicker-here.end").trigger('focus');
			$(".datepicker-here.end").datepicker({ minDate: new Date(formatDate(selectedDate))})
		}
	});
	$( ".datepicker-here.end" ).datepicker({
		onSelect: function( selectedDate ) {
			$( ".datepicker-here.start" ).datepicker({ maxDate: new Date(formatDate(selectedDate))})
			$(".datepicker-here.end").trigger('blur');
		}
	});
}

if($(".datepicker-here.end").length > 0){
	setDependentDate();
}

$('.btn-events').on('click', function(){
	var start = $('input#datepickerStart').val();
	var end = $('input#datepickerEnd').val();
	
	//start = (start == '') ? '01.01.1900' : start;
	start = (start == '') ? $('input#datepickerStart').prop("defaultValue") : start;
	//end = (end == '') ? '01.01.2100' : end;
	end = (end == '') ?  $('input#datepickerEnd').prop("defaultValue") : end;
	
	$('.filter-event').removeClass('active');
	
	var strid = $('#body-content').attr('data-strid');
	var page = 1;
	
	getFilterResults({func: 'get-page-events', page: page, str: strid, dateFrom: start, dateTo: end }, ['func', 'str'], function(jqueryHtml){
		$('.data-content').empty();
		$('.data-content').append(jqueryHtml);
	});
	
});

$('#years-filter #years').on('change', function(e){
	
	var strid = $('#body-content').attr('data-strid');
	var page = 1;
	var year = this.value;
	
	getFilterResults({func: 'get-page-news', page: page, str: strid, year: year }, ['func', 'str'], function(jqueryHtml){
		$('.data-content').empty();
		$('.data-content').append(jqueryHtml);
	});
	
});

$('#categories-filter #categories').on('change', function(e){
	
	var strid = $('#body-content').attr('data-strid');
	var category = this.value;
	
	var funct = 'get-other-institutions';
	
	if(strid.includes('22_')){
		funct = 'get-translations';
	}
	
	getFilterResults({func: funct, str: strid, category: category }, ['func', 'str'], function(jqueryHtml){
		$('.data-content').empty();
		$('.data-content').append(jqueryHtml);
	});
});


$('#tender-filter #status').on('change', function(e){
	
	var strid = $('#body-content').attr('data-strid');
	var page = 1;
	var status = this.value;
	
	getFilterResults({func: 'get-tenders', page: page, str: strid, status: status }, ['func', 'str'], function(jqueryHtml){
		$('.data-content').empty();
		$('.data-content').append(jqueryHtml);
	});
	
});
window.getFilterResults = getFilterResults;
window.onPaginationNewsClick = onPaginationNewsClick;
window.onPaginationEventsClick = onPaginationEventsClick;
window.onPaginationTendersClick = onPaginationTendersClick;
window.onPaginationMaterialsClick = onPaginationMaterialsClick;
window.callNewPageData = callNewPageData;
window.setSimplePagination = setSimplePagination;
window.formatDate = formatDate;
window.setDependentDate = setDependentDate;
}.call(window, window);